<template>
  <div>
    <div class="section-head">累计存款档位设置</div>
    <div class="red-tiers-actions">
      <el-button type="primary" size="mini" @click="addTier">新增</el-button>
    </div>
    <div class="status-tip" style="margin-bottom: 8px">保存时将按存款门槛从低到高排序</div>
    <el-table :data="localForm.payinRebateTiers" border size="mini" class="tier-table">
      <el-table-column label="序号" width="56" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="存款达标金额" min-width="220">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.threshold_yuan"
            :min="0"
            :precision="2"
            :controls="false"
            size="mini"
            style="width: 140px"
            placeholder="请输入存款金额"
          />
        </template>
      </el-table-column>
      <el-table-column label="奖励金额" min-width="220">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.gold_yuan"
            :min="0"
            :precision="2"
            :controls="false"
            size="mini"
            style="width: 140px"
            placeholder="请输入奖励金额"
          />
        </template>
      </el-table-column>
      <el-table-column label="已发放" width="80" align="center">
        <template slot-scope="scope">{{ scope.row.settled_count }}</template>
      </el-table-column>
      <el-table-column label="操作" width="72" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="danger-button" @click="removeTier(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 16px">
      <el-form-item label-width="140px" label="活动循环模式">
        <el-input-number
          v-model="localForm.payinRebateRule.cycle_days"
          :min="1"
          :precision="0"
          :controls="false"
          size="mini"
        />
        <span class="rule-suffix">天</span>
      </el-form-item>

      <el-form-item label-width="140px" label="活动计算模式">
        <el-radio-group v-model="localForm.payinRebateRule.calculate_type">
          <el-radio :label="CALCULATE_TYPE_ACCUMULATE">累加模式(总额累计)</el-radio>
          <el-radio :label="CALCULATE_TYPE_INDEPENDENT">达标模式(差额升级)</el-radio>
        </el-radio-group>
        <div class="status-tip" style="margin-top: 8px">
          <span
            >累加模式(总额累计)指每一档金额为升级所需的存款总额。示例：升级第二档需存满200，若已完成第一档(100),需再存
            <b>200</b>（即总存款达<b>300</b>）方可解锁</span
          >
          <br />
          <span
            >达标模式(差额升级)指每一档金额为升级所需的额外存款额。示例：升级第二档需存满200，若已完成第一档(100),需再存
            <b>100</b>（即总存款达<b>200</b>）即可解锁</span
          >
        </div>
      </el-form-item>

      <el-form-item label-width="140px" label="奖励稽核倍数">
        <el-input-number
          v-model="localForm.payinRebateRule.multiple"
          :min="0"
          :precision="2"
          :controls="false"
          class="rule-input-num"
        />
        <span class="rule-suffix">倍</span>
      </el-form-item>

      <el-form-item label="活动对象" prop="vips" class="form-item-vips" label-width="140px">
        <div class="vips-wrap" style="width: 80%">
          <el-checkbox :indeterminate="vipIndeterminate" :value="isAllVipChecked" @change="onVipCheckAllChange">
            全选
          </el-checkbox>
          <el-checkbox-group v-model="localForm.vips" class="vips-group" @change="syncVipCheckAllState">
            <el-checkbox v-for="item in vipOptions" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef, no-unused-vars */
import { computed } from 'vue'

const DEFAULT_TIER_STEP = 0 //100
const CALCULATE_TYPE_ACCUMULATE = 1
const CALCULATE_TYPE_INDEPENDENT = 2

const props = defineProps({
  localForm: { type: Object, required: true },
  vipOptions: { type: Array, required: true },
})

const emit = defineEmits(['syncVipCheckAllState', 'onVipCheckAllChange'])

const isAllVipChecked = computed(() => {
  const opts = props.vipOptions || []
  return opts.length > 0 && props.localForm.vips.length === opts.length
})
const vipIndeterminate = computed(() => {
  const opts = props.vipOptions || []
  const n = props.localForm.vips.length
  return n > 0 && n < opts.length
})

function syncVipCheckAllState() {
  emit('syncVipCheckAllState')
}
function onVipCheckAllChange(val) {
  emit('onVipCheckAllChange', val)
}

function createEmptyTier() {
  return {
    id: '',
    threshold_yuan: DEFAULT_TIER_STEP,
    gold_yuan: undefined,
    settled_count: 0,
  }
}

function addTier() {
  const list = props.localForm.payinRebateTiers || []
  const next = createEmptyTier()
  const prev = list[list.length - 1]
  // if (prev && Number.isFinite(Number(prev.threshold_yuan))) {
  //   next.threshold_yuan = Number(prev.threshold_yuan) + DEFAULT_TIER_STEP
  // }
  list.push(next)
}

function removeTier(index) {
  if ((props.localForm.payinRebateTiers || []).length <= 1) return
  props.localForm.payinRebateTiers.splice(index, 1)
}
</script>

<style lang="scss" scoped>
.section-head {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin: 16px 0 12px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  line-height: 1.2;
}

.rule-input-num {
  width: 120px;
}

.rule-suffix {
  color: #606266;
  font-size: 13px;
  margin-left: 4px;
}

.status-tip {
  font-size: 12px;
  color: #999;
}

.red-tiers-actions {
  margin-bottom: 8px;
}

.danger-button {
  color: #f56c6c;
}

.form-item-vips {
  align-items: flex-start;
}

.vips-wrap {
  width: 100%;
}

.vips-group {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}
</style>
